import { Author, Content } from '@/lib/model';
import { getAuthorLinkWithId } from '@/utils/links/author';
import { LinkWithChannelLink } from '../../link/LinkWithChannel';
import { cn } from '@/lib/utils';

type Props = {
  content?: Content;
  prefix?: string;
  noLink?: boolean;
  limit?: number;
  className?: string;
  dataTestId?: string;
};

const AuthorRow = ({
  name,
  id,
  id_,
  hasMoreAuthor,
  noLink,
}: {
  name: string;
  id: string;
  id_: string;
  hasMoreAuthor?: boolean;
  noLink?: boolean;
}) => {
  return noLink ? (
    <>{` ${name}${hasMoreAuthor ? ', ' : ''}`}</>
  ) : (
    <LinkWithChannelLink
      className="inline-block"
      href={getAuthorLinkWithId(id || id_)}
    >
      <>{` ${name}${hasMoreAuthor ? ', ' : ''}`}</>
    </LinkWithChannelLink>
  );
};

export function PlatformAuthorName({
  content,
  prefix,
  noLink,
  limit = 2,
  className,
  dataTestId,
}: Props) {
  const authors = [
    content?.author as Author,
    ...(content?.otherAuthors || []),
  ]?.filter(a => a?.id || a?.id_) as Array<Author>;

  const hasExtraAuthors = authors.length > limit;

  return (
    <div
      className={cn('whitespace-break-spaces', className)}
      data-testid={dataTestId}
    >
      {authors.length && prefix ? prefix : null}
      {authors?.slice(0, limit)?.map((author, index) => {
        const hasMoreAuthor = Boolean(authors.length > 1 && index < limit - 1);

        return (
          <AuthorRow
            key={author?.id || author?.id_}
            {...author}
            hasMoreAuthor={hasMoreAuthor}
            noLink={noLink}
          />
        );
      })}
      {hasExtraAuthors ? <>, ...</> : null}
    </div>
  );
}
